import { render, staticRenderFns } from "./privacy-policy.vue?vue&type=template&id=8714fea0&scoped=true"
import script from "./privacy-policy.vue?vue&type=script&lang=js"
export * from "./privacy-policy.vue?vue&type=script&lang=js"
import style0 from "./privacy-policy.vue?vue&type=style&index=0&id=8714fea0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8714fea0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8714fea0')) {
      api.createRecord('8714fea0', component.options)
    } else {
      api.reload('8714fea0', component.options)
    }
    module.hot.accept("./privacy-policy.vue?vue&type=template&id=8714fea0&scoped=true", function () {
      api.rerender('8714fea0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/paycools/register/privacy-policy.vue"
export default component.exports